import { QueovalBase } from '../global';

export class StatistiqueModel extends QueovalBase {
  public StatElearning: StatistiqueElearning;
}

export class StatistiqueElearning {
  public ListCycleEL: StatistiqueListCycleEL;
  public DetailCycleEL: StatistiqueDetailCycleEL;
  public AvancementChapitreEL: StatistiqueAvancementChapitreEL;
  public DetailApprenantEL: StatistiqueDetailApprenantEL;
  public DetailNoteChapitreEL: StatistiqueDetailNoteChapitreEL;
}

// #region PAGE LIST CYCLE
export class StatistiqueListCycleEL {
  public CycleInfo: Array<CycleInfo>;
}

export class CycleInfo {
  public identCyc: number;
  public NomCyc: string;
  public PhotoCyc: string;
  public NbApprenantCyc: number;
  public NbChapitre: number;
}
// #endregion

// #region PAGE DETAIL CYCLE
export class StatistiqueDetailCycleEL {
  public CycleInfo: Array<CycleInfo>;
  public NbInscrit: number;
  public ListInactif: Array<ApprenantEL>;
  public ListEnCours: Array<ApprenantEL>;
  public ListComplete: Array<ApprenantEL>;
  public ListChapitre: Array<any>;
  public ListInscrit: Array<ApprenantEL>;
}

export class ApprenantEL {
  public Ident: number;
  public Nom: string;
  public Prenom: string;
  public Mail: string;
  public NomConnexion: string;
}
// #endregion

// #region PAGE DETAIL APPRENANT
export class StatistiqueDetailApprenantEL {
  public PathImgApprenant: string;
  public QuestionTraitee: string;
  public ModuleTermine: string;
  public TempsPasse: string;
  public TauxReussite: string;
  public InfoApprenant: Array<any>;
  public ListChapitre: Array<any>;
  public CycleInfo: Array<CycleInfo>;
}
// #endregion

// #region GRAPH AVANCEMENT CHAPITRE EL
export class StatistiqueAvancementChapitreEL {
  public NbApprenant: number;
  public ListAvancement: Array<number>;
  public ListModule: Array<string>;
}
// #endregion

// #region GRAPH DETAIL NOTE D'UN CHAPITRE
export class StatistiqueDetailNoteChapitreEL {
  public ListModule: Array<string>;
  public ListNoteApprenant: Array<NoteGraph>;
  public ListMoyNoteChapitre: Array<NoteGraph>;
  public ListNoteMin: Array<NoteGraph>;
  public ListNoteEcart: Array<NoteGraph>;
}

export class NoteGraph {
  public name: string;
  public value: Array<any>;
}
// #endregion

